import {translations} from 'presentation/translations-new';

const {stepsTitleMobile} = translations['pt-br'].privateFlow.bookingFlow;
const {
	neighborhood,
	unit,
	professional,
	specialty,
	confirm,
	location: locationTitle,
} = stepsTitleMobile;

const HEADER_TITLES = {
	withGeo: [locationTitle, specialty, unit, professional, confirm],
	withoutGeo: [locationTitle, specialty, neighborhood, unit, professional, confirm],
};

export {HEADER_TITLES};
